import useSWR from 'swr';

import { SWRFetcher } from '@commenda/utils';

import { McpToolCatalogResponse } from './types';

const CATALOG_URL = 'mcp-tool-catalog';

/** Not company-scoped: a tool's company clamp is applied when it runs, not when it is listed. */
export const useMcpToolCatalog = (options?: { enabled?: boolean }) => {
  const enabled = options?.enabled ?? true;

  const { data, error, isLoading, mutate } = useSWR<McpToolCatalogResponse>(
    enabled ? CATALOG_URL : null,
    SWRFetcher({ method: 'GET' })
  );

  return { tools: data?.tools, error, isLoading, mutate };
};
